import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) =>
  state.individualDashboard || initialState;

export const selectIndividualDashboard = createSelector(
  [selectSlice],
  state => state,
);
